module.exports = __webpack_public_path__ + "img/metal.f4e87bf.webp";